import React from "react";
import styled from "styled-components";
import Image from "gatsby-image";
import { Body, DomeText, Header3 } from "../components/typography";
import { Colors } from "../components/styles/Colors";
import Breakpoints from "../components/styles/Breakpoints";
import { Link } from "gatsby";

const Wrapper = styled.div`
  color: ${Colors.cream1};
  background: ${(props) => props.color};

  padding: 64px 32px;

  display: block;

  text-decoration: none;

  ${DomeText} {
    display: block;
    color: ${Colors.cream1};
    margin-bottom: 40px;
  }

  ${Header3} {
    margin-bottom: 40px;
  }

  .gatsby-image-wrapper {
    max-width: 310px;
    max-height: 310px;

    margin: 32px auto 0;

    display: block !important;
  }

  > div {
    max-width: 1400px;
    margin: 0 auto;
  }

  @media ${Breakpoints.tablet} {
    > div {
      display: grid;
      grid-template-columns: 40% 60%;
    }

    > div > div:first-child {
      display: flex;
      flex-direction: column;
      justify-content: center;
      // align-items: center;
    }

    > div > div:last-child {
      display: flex;
      justify-content: flex-end;
    }

    .gatsby-image-wrapper {
      max-width: unset;
      max-height: unset;

      display: inline-block !important;

      margin: 0;
    }
  }
`;

function slugify(str) {
  return str
    ?.toLowerCase()
    .replace(/ /g, "-")
    .replace(/[-]+/g, "-")
    .replace(/[^\w-]+/g, "");
}

export default function FeaturedBlogPost({ category, post }) {
  return (
    <Wrapper
      as={Link}
      to={`/blog/${slugify(category.headline)}/${post.slug}`}
      color={category.color}
    >
      <div>
        <div>
          <DomeText>Featured {category.name}</DomeText>
          <Header3>{post.title}</Header3>
          <Body>
            You did it! You took the plunge, made the leap, and decided to take
            it all off and own the bald lifestyle.
          </Body>
        </div>
        <div>
          <Image fixed={post.image.fixed} />
        </div>
      </div>
    </Wrapper>
  );
}
